// extracted by mini-css-extract-plugin
export default {"img":"hero_img__Baq++","relative":"hero_relative__94Bcf","antidea":"hero_antidea__ZMEk-","logo":"hero_logo__jg5fq","discovermore":"hero_discovermore__YEeRs"};